import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { isNavigationSubMenuTitlesEnabled } from 'selectors/featureToggles';
import { Icon } from 'xm-spark';
import { placeMatchesCurrentPath } from 'utils/navigation';

import SubNavMenuItem from '../SubNavMenuItem';

import styles from './SubNavMenu.module.scss';

const itemIsActive = ({ id, to, isActive, exclude = [] }) =>
  isActive ? isActive({ id, to }) : placeMatchesCurrentPath(to, exclude);

const getGroupTitle = (intl, id, name) =>
  id ? intl.formatMessage({ id }) : name;

const SubNavMenu = ({ nav, onClose }) => {
  const intl = useIntl();
  const isNavigationSubMenuTitles = useSelector(
    isNavigationSubMenuTitlesEnabled,
  );

  if (!nav) {
    return null;
  }

  const onCloseKeyUp = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClose();
    }
  };

  return (
    <div className={styles.subNavMenu} data-testid="mainNav_subNavMenu">
      <div className={styles.closeContainer}>
        <div
          role="button"
          tabIndex={0}
          className={styles.close}
          onClick={onClose}
          onKeyUp={onCloseKeyUp}
          title={intl.formatMessage({ id: 'CLOSE' })}
        >
          <Icon type="icon-cancel" />
        </div>
      </div>
      {isNavigationSubMenuTitles && (
        <div className={styles.title}>
          <FormattedMessage id={nav.textCode} />
        </div>
      )}

      {nav.subNav.map(({ id, name, items }) => {
        return (
          <div key={id || name} className={styles.group}>
            {isNavigationSubMenuTitles && (
              <div
                className={styles.groupTitle}
                title={getGroupTitle(intl, id, name)}
              >
                {getGroupTitle(intl, id, name)}
              </div>
            )}
            <ul className={styles.itemList}>
              {items.map(item => (
                <SubNavMenuItem
                  key={item.id}
                  intl={intl}
                  item={item}
                  isActive={itemIsActive(item)}
                  onClose={onClose}
                />
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

SubNavMenu.displayName = 'SubNavMenu';
SubNavMenu.defaultProps = {
  nav: null,
};
SubNavMenu.propTypes = {
  nav: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
};

export default SubNavMenu;
